import classNames from 'classnames'
import { Icon, Typography } from 'src/modules/core/components'
import type { TypeCancellationPolicyRowProps } from './type-cancellation-policy-row.interface'
import classes from './type-cancellation-policy-row.module.scss'

export function TypeCancellationPolicyRow({ summary, isOpen, onOpen }: TypeCancellationPolicyRowProps) {
  return (
    <button
      type="button"
      className={classNames(classes.row, { [classes.open]: isOpen })}
      aria-pressed={isOpen}
      onClick={onOpen}
      data-testid="type-cancellation-policy-row"
    >
      <span className={classes.text}>
        <Typography variant="body" element="span" className={classes.title}>
          Cancellation Policy
        </Typography>
        <Typography variant="body" element="span" className={classes.summary} data-testid="type-policy-summary">
          {summary}
        </Typography>
      </span>
      <Icon name="chevronRight" className={classes.chevron} />
    </button>
  )
}
